import { render, staticRenderFns } from "./UploadedFileStatus.vue?vue&type=template&id=3b65473a&scoped=true"
import script from "./UploadedFileStatus.vue?vue&type=script&lang=js"
export * from "./UploadedFileStatus.vue?vue&type=script&lang=js"
import style0 from "./UploadedFileStatus.vue?vue&type=style&index=0&id=3b65473a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b65473a",
  null
  
)

export default component.exports